import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const AccordionItem = ({
  group,
  isOpen,
  onToggle,
  selectedServices,
  onSelectService,
  handleQuantityChange,
}) => {
  return (
    <div className="accordion-item ">
      <h2 className="accordion-header">
        <button
          className="accordion-button   bg-success"
          type="button"
          onClick={onToggle}
          aria-expanded="true"
          aria-controls="collapseOne"
        >
          {group.name}
        </button>
      </h2>

      <div
        id="collapseOne"
        className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
        data-bs-parent="#accordionExample"
      >
        <div className="accordion-body">
          <ul className="list-unstyled p-3 mb-0">
            {group.services.map((ser) => {
              const isSelected = selectedServices.some(
                (s) => s.serviceId === ser.id,
              );
              return (
                <>
                  <li
                    key={ser.id}
                    className={`mb-2 p-2 rounded ${
                      isSelected ? "bg-primary text-white" : "bg-light"
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => onSelectService(ser.id)}
                  >
                    <span className="pe-4">{ser.name}</span>
                    <span className="pe-4">Price: {ser.price}</span>
                    <span className="pe-4">
                      Time: {ser.barberServices[0].time}
                    </span>
                  </li>
                  <li>
                    {ser.isRepeatable && isSelected && (
                      <div className="d-flex justify-content-end service-quantity">
                        <div
                          className="input-group mb-2 "
                          style={{ width: "150px" }}
                        >
                          {/* Minus Button */}
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() =>
                              handleQuantityChange(
                                ser.id,
                                Math.max(
                                  1,
                                  (selectedServices.find(
                                    (s) => s.serviceId === ser.id,
                                  )?.quantity || 1) - 1,
                                ),
                              )
                            }
                          >
                            −
                          </button>

                          {/* Text Input with validation */}
                          <input
                            type="text"
                            className="form-control text-center"
                            value={
                              selectedServices.find(
                                (s) => s.serviceId == ser.id,
                              )?.quantity || 1
                            }
                            onChange={(e) => {
                              let value = e.target.value;
                              // Allow only digits
                              value = value.replace(/\D/g, "");

                              // Prevent empty input
                              if (value === "") value = "1";

                              // Convert to number
                              let number = parseInt(value, 10);

                              // Apply limits
                              if (number < 1) number = 1;
                              if (number > 5) number = 5;

                              handleQuantityChange(ser.id, number);
                            }}
                          />

                          {/* Plus Button */}
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() =>
                              handleQuantityChange(
                                ser.id,
                                Math.min(
                                  5,
                                  (selectedServices.find(
                                    (s) => s.serviceId === ser.id,
                                  )?.quantity || 1) + 1,
                                ),
                              )
                            }
                          >
                            +
                          </button>
                        </div>
                      </div>
                    )}
                  </li>
                </>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};
export default AccordionItem;
